import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CertificadoDigitalService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  enviarCertificadoDigital(certificadoBase64: string, senha: string): Observable<any> {
    const body = {
      CertificadoBase64: certificadoBase64,
      Senha: senha
    };
    return this.http.post(`${this.serviceApi}/v1/sistemas-externos/certificado-digital`, body);
  }

}

